import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigService } from '../../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../../problems/problem.service';
import { GetCurrenciesResponseInterface } from '../definitions/get-currencies-response.interface';

@Injectable()
export class GetCurrenciesService {
    constructor(private client: HttpClient, private configService: ConfigService) {}
  
    public getCurrencies(): Observable<Array<GetCurrenciesResponseInterface>> {
      const url = `${this.configService.config.rest.apiV2Url}/currencies`;
  
      return this.client.get<Array<GetCurrenciesResponseInterface>>(url).pipe(
        catchError(error => throwError(handleProblem(error)))
      );
    }
}